import type { TicketingCategory } from '@cpce/shared';
import { query } from '@/api/queries.utils';
import { categoriesQueryKeys } from './transaction-categories.query-keys';

export function useCategories() {
  return query<TicketingCategory[]>({
    queryKey: categoriesQueryKeys.all,
    url: '/categories',
  });
}
